import { render, staticRenderFns } from "./AreaDetail.vue?vue&type=template&id=e436d2e8&scoped=true&"
import script from "./AreaDetail.vue?vue&type=script&lang=js&"
export * from "./AreaDetail.vue?vue&type=script&lang=js&"
import style0 from "./AreaDetail.vue?vue&type=style&index=0&id=e436d2e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e436d2e8",
  null
  
)

export default component.exports